import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { MenuItem } from 'ng2-material-components/ng2-material-components';

@Injectable()
export class AppStateService {

    private appState: {
        headerActions: MenuItem[],
    };

    private _showBackAction: boolean;
    private _headerActions: Subject<MenuItem[]>;
    private _backAction: BehaviorSubject<boolean>;

    constructor() {
        this._backAction = new BehaviorSubject<boolean>(false);
    }

    get headerActions$(): Observable<MenuItem[]> {
        return this._headerActions.asObservable();
    }

    get backAction$(): Observable<boolean> {
        return this._backAction.asObservable();
    }

    changeHeaderActions(actions: MenuItem[]) {
        this.appState.headerActions = actions;
        this._headerActions.next(this.appState.headerActions);
    }

    changeBackActionValue(value: boolean) {
        this._showBackAction = value;
        this._backAction.next(this._showBackAction);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/services/app-state.service.ts